var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"qrCodeArea"},[_c('ul',{staticClass:"list-qr"},_vm._l((_vm.qrArray),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"qr"},[_c('QRCodeStyling',{attrs:{"imageOptions":{
            crossOrigin: 'anonymous',
            margin: 10,
            imageSize: 0.5,
          },"size":300,"data":item.qrCode}})],1),_c('div',{staticClass:"bank"},[_vm._v(_vm._s(item.bankAccountNumber))]),_c('div',{staticClass:"bank-name"},[_vm._v(_vm._s(item.bankCode))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }